import { render, staticRenderFns } from "./TeamOverview.vue?vue&type=template&id=af26281e&scoped=true&"
import script from "./TeamOverview.vue?vue&type=script&lang=ts&"
export * from "./TeamOverview.vue?vue&type=script&lang=ts&"
import style0 from "./TeamOverview.vue?vue&type=style&index=0&id=af26281e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af26281e",
  null
  
)

export default component.exports